import { t } from '@lingui/core/macro';
import { createFileRoute } from '@tanstack/react-router';

import { SpendReportsPage } from './-spend-reports-page';

export const Route = createFileRoute(
  '/researchers/_authenticated/billing/spend-reports',
)({
  component: SpendReportsRoute,
  head: () => ({ meta: [{ title: t`Spend reports` }] }),
});

function SpendReportsRoute() {
  const { user, activeDashboard, hasLegacyPricing } = Route.useRouteContext();
  return (
    <SpendReportsPage
      user={user}
      activeDashboard={activeDashboard}
      hasLegacyPricing={hasLegacyPricing}
    />
  );
}
